<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"

    :loading="isLoading"
    :items="sortedItems"
    :value="value"
    :error-messages="requestError ? [requestError.message] : []"

    auto-select-first
    :filter="customFilter"
    :search-input.sync="searchQuery"
    @change="() => searchQuery = null"
    @focus="() => fetchItems()"
  >
    <template v-slot:prepend-item v-if="showSelectAll && hasResults">
      <v-list-item @click="() => toggleSelectAll()">
        <v-list-item-action>
          <v-icon :color="selectAllIconColor">
            {{ selectAllIcon }}
          </v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            Selecionar todos
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />
    </template>
  </v-autocomplete>
</template>

<script>
import store from '@/services/store';

export default {
  name: 'HouseFundsSelector',

  inheritAttrs: false,

  // NOTE: "value" must be set as a prop for v-model to work properly
  // @see (https://github.com/vuejs/vue/issues/8430)
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },

    showSelectAll: {
      type: Boolean,
      default: false,
    },

    includeAllFunds: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    searchQuery: null,
  }),

  computed: {
    requestError: () => store.state.houseFunds?.requestError ?? null,
    isLoading: () => store.getters['houseFunds/isLoading'] ?? false,

    activeHouseFunds: () => store.getters['houseFunds/activeHouseFunds'] ?? [],
    externalHouseFunds: () => store.getters['houseFunds/externalHouseFunds'] ?? [],

    items: (vm) => (vm.includeAllFunds ? vm.activeHouseFunds : vm.externalHouseFunds),
    hasResults: (vm) => vm.items.length > 0,

    sortedItems: (vm) => {
      const items = [...vm.items];

      return items.sort((itemA, itemB) => (itemA.shortName > itemB.shortName ? 1 : -1));
    },

    hasSelectedAll: (vm) => vm.value.length === vm.items.length,
    hasSelectedSome: (vm) => vm.value.length > 0 && !vm.hasSelectedAll,
    selectAllIconColor: (vm) => (vm.value.length > 0 ? 'indigo darken-4' : ''),
    selectAllIcon: (vm) => {
      if (vm.hasSelectedAll) return 'mdi-close-box';
      if (vm.hasSelectedSome) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },

  methods: {
    customFilter(item, queryText) {
      const query = queryText.toLowerCase();
      const index1 = item.shortName.toLowerCase();

      return index1.includes(query);
    },

    toggleSelectAll() {
      if (this.hasSelectedAll) {
        this.$emit('change', []);
        return;
      }

      const itemValueIndex = this.$attrs['item-value'];
      this.$emit('change', this.items.map((item) => item[itemValueIndex]));
    },

    async fetchItems() {
      const MIN_INTERVAL = 10 * 60 * 1000;

      const lastResponseDate = store.state.houseFunds?.lastResponseDate ?? null;
      const hasRequested = store.getters['houseFunds/hasRequested'] ?? false;

      const duration = Date.now() - Date.parse(lastResponseDate);

      if (hasRequested && duration <= MIN_INTERVAL) {
        return;
      }

      await store.dispatch('houseFunds/fetchList');
    },
  },
};
</script>
